import Ratings from './Ratings';

export { Ratings };
export default Ratings;
